import { AggregatedParticipants, Participant } from "./enrollment.entities";
import { ChartLine } from "./enrollment.chart-line";
import { ChartPie } from "./enrollment.chart-pie";
import { EnrollmentLookup } from "./enrollment.lookup";
import { IEnrollmentPageData } from "./enrollment.page";
import { CreateSeries_ActualDays } from "../../../../shared/scripts/graphing/graphing-functions";
import { ChartBar } from "./enrollment.chart-bar";
import { SumArrayElements } from "../../../../shared/scripts/array-functions";
import { Study } from "../../../../shared/entities/scripts/study";
import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";

const extendedColors = 
    [
        "#E9C46A", //0
        "#77A6B6", //1
        "#99C2A2", //2
        "#994636", //5
        "#0075A2", //6
        "#805d93", //14
        "#A26B73", //7
        "#cd533b", //10
        "#0a2463", //9
        "#636940", //11
        "#A288A6", //3
        "#902d41", //8
        "#F4A261", //4
        "#26547c", //12
        "#AF3B6E", //13
    ];

export { extendedColors };
export class ChartController {

    parent: IEnrollmentPageData;

    lineChart: ChartLine;
    barChart: ChartBar;
    pieChart: ChartPie;

    currNumSeries: number = 0;

    constructor(parent: IEnrollmentPageData) {
        this.parent = parent;
        this.lineChart = new ChartLine();
        this.barChart = new ChartBar();
        this.pieChart = new ChartPie(parent);
    }

    UpdateData(): void {

        if (this.parent.selectedGraphView == "Cumulative" || this.parent.selectedGraphView == "ByMonth" || this.parent.selectedGraphView == "RatePerSiteByMonth" || this.parent.selectedGraphView == "ByWeek") {

            let chartSetup: ChartSetup;

            if (this.parent.selectedAggregation == "Overall") { chartSetup = this.createSeriesForOverall(); }
            else { chartSetup = this.createSeriesForAggregation(); }

            if (this.parent.selectedGraphView == "Cumulative") {
                if (chartSetup.moreThan15Points) { chartSetup.series.forEach((s: ChartSeries) => s.step = undefined); }
                this.lineChart.UpdateChart(chartSetup);
                //this.updateLineChart(series, showLegend);
            }
            else if (this.parent.selectedGraphView == "ByMonth") {
                if (this.parent.percentageBars) {
                    chartSetup.series = chartSetup.series.filter(series => { return !series.name.toLowerCase().includes("expected"); });
                }
                this.barChart.UpdateChart(chartSetup, undefined, undefined, undefined, this.parent.percentageBars);
            }
            else if (this.parent.selectedGraphView == "ByWeek") {
                //if (this.parent.selectedAggregation != "BySite" && this.parent.selectedPopulation == "randomized") { chartSetup.series.pop(); }
                chartSetup.series = chartSetup.series.filter(series => { return !series.name.toLowerCase().includes("expected"); });

                chartSetup.showForecast = false;
                this.barChart.UpdateChart(chartSetup, undefined, undefined, 'Week of %d %b %Y', this.parent.percentageBars);
            }
            else if (this.parent.selectedGraphView == "RatePerSiteByMonth") {
                if (this.parent.percentageBars) {
                    chartSetup.series = chartSetup.series.filter(series => { return !series.name.toLowerCase().includes("expected"); });
                }
                this.barChart.UpdateChart(chartSetup, 'Participants per Site', 2, undefined, this.parent.percentageBars);
                //    this.updateBarChart(series, showLegend, showingForecast, 'Participants per Site', 2);
                //console.log(series);
            }

            this.currNumSeries = chartSetup.series.filter(series => { return !series.name.toLowerCase().includes("expected"); }).length;
        }
        else if (this.parent.selectedGraphView == "Proportional") {
            if (this.parent.selectedBreakdown != "All Participants") {
                this.pieChart.UpdatePieChart(this.getIndices());
                this.currNumSeries = this.getIndices().length;
            }
            else { //no breakdown selected
                this.pieChart.UpdatePieChart(undefined);
                this.currNumSeries = 2;
            }
        }

        if ((this.parent.selectedGraphView == "ByWeek" || this.parent.selectedGraphView == "ByMonth" || this.parent.selectedGraphView == "RatePerSiteByMonth") && this.currNumSeries > 1) {

            $('#percentages-toggle').show();
        } else {
            $('#percentages-toggle').hide();
            if (this.parent.percentageBars) {
                $("#percentages-switch").prop("checked", false);
                this.parent.percentageBars = false;
                this.UpdateData();
            }
        }

    }

    public createSeriesForOverall(selectedParticipants: Participant[] = this.parent.selectedParticipants): ChartSetup {

        let series: ChartSeries[] = [];
        let indices: number[] = this.getIndices();

        let showingForecast: boolean = false;
        let moreThan15Points: boolean = false;
        let showLegend: boolean = true;

        let legendIndex: number = 0;
        indices.forEach((i: number) => {
            let currentSeries: ChartSeries = this.createChartSeries(i, legendIndex++);
            if (this.parent.selectedBreakdown == "All Participants") { currentSeries.data = this.createChartData(selectedParticipants); }
            else if (this.parent.selectedBreakdown == "RECOVER Cohort") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.RecoverCohort == i)); }
            else if (this.parent.selectedBreakdown == "Race") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.RaceId == i)); }
            else if (this.parent.selectedBreakdown == "Ethnicity") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.HispanicId == i)); }
            else if (this.parent.selectedBreakdown == "Hispanic or Non-White") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.NonWhiteHispanic == i)); }
            else if (this.parent.selectedBreakdown == "Sex") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.SexId == i)); }
            else if (this.parent.selectedBreakdown == "Age") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.AgeId == i)); }
            else if (this.parent.selectedBreakdown == "SX Cluster: ExInt (Enrolled)") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.VitSymExInt == i)); }
            else if (this.parent.selectedBreakdown == "SX Cluster: CogDys (Enrolled)") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.VitSymCogDys == i)); }
            else if (this.parent.selectedBreakdown == "SX Cluster: Autonomic (Enrolled)") { currentSeries.data = this.createChartData(selectedParticipants.filter((p: Participant) => p.VitSymAutoDys == i)); }

            if (currentSeries.data.length >= 15) { moreThan15Points = true; }
            series.push(currentSeries);
        });

        if (this.parent.selectedBreakdown == "All Participants" && this.parent.selectedForecastRandomized.length > 0) {
            series.push(this.createForecastChartSeries());
            showingForecast = true;
        }

        return new ChartSetup(series, showingForecast, moreThan15Points, showLegend);
    }

    private createSeriesForAggregation(): ChartSetup {

        let series: ChartSeries[] = [];
        let showingForecast: boolean = false;
        let moreThan15Points: boolean = false;
        let showLegend: boolean = true;

        if (this.parent.selectedAggregation == "ByStudy") {
            this.parent.allStudies.forEach((s: Study) => {
                let studySeries: ChartSeries = new ChartSeries(this.parent.selectedGraphView);
                studySeries.name = s.Name;
                studySeries.color = this.getSeriesColor(s.Name);
                studySeries.data = this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.StudyId == s.Id));
                if (studySeries.data.length > 0) {
                    if (studySeries.data.length >= 15) { moreThan15Points = true; }
                    series.push(studySeries);
                }
            });

            //series.length == 1 && 
            if (this.parent.selectedForecastRandomized.length > 0) {
                series.push(this.createForecastChartSeries());
            }
        }
        else if (this.parent.selectedAggregation == "ByAppendix") {
            let appendicies: Appendix[] = this.parent.allAppendices;
            if (this.parent.showUnassigned) {
                appendicies = appendicies.concat(this.parent.unassignedAppendicies);
            }
            appendicies.forEach((a: Appendix) => {
                //make an unassigned apenddices array and add that to the all appendices array if the toggle is true

                let appendixSeries: ChartSeries = new ChartSeries(this.parent.selectedGraphView);
                appendixSeries.name = a.Name;
                appendixSeries.color = this.getSeriesColor(a.Name);
                appendixSeries.data = this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == a.Id));
                if (appendixSeries.data.length > 0) {
                    if (appendixSeries.data.length >= 15) { moreThan15Points = true; }
                    series.push(appendixSeries);
                }
            });

            if (this.parent.selectedForecastRandomized.length > 0) {
                series.push(this.createForecastChartSeries());
            }
        }
        else if (this.parent.selectedAggregation == "BySite") {
            let currColorIdx = 0;
            this.parent.consentedSites.forEach((s: Site) => {
                let siteSeries: ChartSeries = new ChartSeries(this.parent.selectedGraphView);
                siteSeries.name = s.Name;
                siteSeries.color = extendedColors[currColorIdx % extendedColors.length];
                currColorIdx++;
                siteSeries.data = this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.SiteNumber == s.Id));
                if (siteSeries.data.length > 0) {
                    if (siteSeries.data.length >= 15) { moreThan15Points = true; }
                    series.push(siteSeries);
                }
            });
            showLegend = false;
        }

        return new ChartSetup(series, showingForecast, moreThan15Points, showLegend);
    }


    public getIndices(): number[] {
        switch (this.parent.selectedBreakdown) {
            case 'All Participants': return [0]; //"ALL" | 0: actual | 1: expected
            case 'RECOVER Cohort': return [1, 0, 2];
            case 'Race': return [1, 2, 3, 4, 5, 6, 0, 7];
            case 'Ethnicity': return [1, 0, 2];
            case 'Hispanic or Non-White': return [1, 0, 2];
            case 'Sex': return [0, 1, 2, 3, 4];
            //case 'Age': return [0, 1, 2, 3, 4];
            case 'Age': return [0, 1, 2, 3];
            case 'SX Cluster: ExInt (Enrolled)': return [1, 0, 2];
            case 'SX Cluster: CogDys (Enrolled)': return [1, 0, 2];
            case 'SX Cluster: Autonomic (Enrolled)': return [1, 0, 2];
            default: return [];
        }
    }

    private createChartSeries(index: number, legendIndex: number): ChartSeries {

        let series: ChartSeries = new ChartSeries(this.parent.selectedGraphView);
        series.legendIndex = legendIndex;
        series.marker = {
            lineWidth: '0',
            lineColor: series.color,
        };

        if (this.parent.selectedBreakdown == "All Participants") {
            if (index == 0) { //actual
                series.name = "Actual";
                series.color = "#152850"; //recover dark blue
            }
            else if (index == 1) {
                series.name = "Expected";
                series.color = "#de4846"; //reddish
                series.dashStyle = 'dot';
                series.type = 'lollipop';
                series.connectorWidth = 2;
                series.marker = { radius: 3, symbol: 'circle' };
                return series;
            }
        }
        else if (this.parent.selectedBreakdown == "RECOVER Cohort" || this.parent.selectedBreakdown == "Ethnicity" || this.parent.selectedBreakdown == "Hispanic or Non-White" || this.parent.selectedBreakdown == "SX Cluster: ExInt (Enrolled)" || this.parent.selectedBreakdown == "SX Cluster: CogDys (Enrolled)" || this.parent.selectedBreakdown == "SX Cluster: Autonomic (Enrolled)") {
            series.name = EnrollmentLookup.GetYesNo(index);
            if (this.parent.selectedBreakdown == "Ethnicity" && series.name != "Unknown") {
                series.name = (series.name == "Yes") ? "Hispanic" : "Not Hispanic";
            }
            switch (index) {
                case 1: series.color = "#77A6B6"; break;
                case 0: series.color = "#E9C46A"; break;
                case 2: series.color = "#6e6e6e"; break;
            };
        }
        else if (this.parent.selectedBreakdown == "Sex") {
            series.name = EnrollmentLookup.GetSex(index);
            switch (index) {
                case 0: series.color = "#77A6B6"; break;
                case 1: series.color = "#E9C46A"; break;
                case 2: series.color = "#99C2A2"; break;
                case 3: series.color = "#A288A6"; break;
                case 4: series.color = "#6e6e6e"; break;
            };
        }
        else if (this.parent.selectedBreakdown == "Age") {
            series.name = EnrollmentLookup.GetAgeGroup(index);
            switch (index) {
                case 0: series.color = "#E9C46A"; break;
                case 1: series.color = "#77A6B6"; break;
                case 2: series.color = "#99C2A2"; break;
                case 3: series.color = "#6e6e6e"; break;
                //case 3: series.color = "#99C2A2"; break;
                //case 4: series.color = "#6e6e6e"; break;
            };
        }
        else if (this.parent.selectedBreakdown == "Race") {
            series.name = EnrollmentLookup.GetRace(index);
            switch (index) {
                case 0: series.color = "#99C2A2"; break;
                case 1: series.color = "#F4A261"; break;
                case 2: series.color = "#A288A6"; break;
                case 3: series.color = "#77A6B6"; break;
                case 4: series.color = "#994636"; break;
                case 5: series.color = "#0075A2"; break;
                case 6: series.color = "#E9C46A"; break;
                case 7: series.color = "#6e6e6e"; break;
            }
        }

        return series;
    }

    public getBreakdownColor(index: number) : string {
        if (this.parent.selectedBreakdown == "RECOVER Cohort" || this.parent.selectedBreakdown == "Ethnicity" ||
            this.parent.selectedBreakdown == "Hispanic or Non-White" || this.parent.selectedBreakdown == "SX Cluster: ExInt (Enrolled)" ||
            this.parent.selectedBreakdown == "SX Cluster: CogDys (Enrolled)" || this.parent.selectedBreakdown == "SX Cluster: Autonomic (Enrolled)") {
            switch (index) {
                case 1: return "#77A6B6";
                case 0: return "#E9C46A";
                case 2: return "#6e6e6e";
            };
        }
        else if (this.parent.selectedBreakdown == "Sex") {
            switch (index) {
                case 0: return "#77A6B6";
                case 1: return "#E9C46A";
                case 2: return "#99C2A2";
                case 3: return "#A288A6";
                case 4: return "#6e6e6e";
            };
        }
        else if (this.parent.selectedBreakdown == "Age") {
            switch (index) {
                case 0: return "#E9C46A";
                case 1: return "#77A6B6";
                case 2: return "#99C2A2";
                case 3: return "#6e6e6e";
            };
        }
        else if (this.parent.selectedBreakdown == "Race") {
            switch (index) {
                case 0: return "#99C2A2";
                case 1: return "#F4A261";
                case 2: return "#A288A6";
                case 3: return "#77A6B6";
                case 4: return "#994636";
                case 5: return "#0075A2";
                case 6: return "#E9C46A";
                case 7: return "#6e6e6e";
            }
        }
    }


    private getSeriesColor(label: string): string {
        if (label == "VITAL") { return "#77A6B6"; }
        else if (label == "NEURO") { return "#E9C46A"; }
        else if (label == "AUTONOMIC") { return "#A288A6"; }
        else if (label == "SLEEP") { return "#99C2A2"; }
        else if (label == "ENERGIZE") { return "#f4a261"; }
        else if (label == "VITAL-1 (Paxlovid)") { return "#77A6B6"; }
        else if (label == "NEURO-1 (tDCS & BrainHQ)") { return "#E9C46A"; }
        else if (label == "AUTONOMIC-1 (IVIG)") { return "#A288A6"; }
        else if (label == "AUTONOMIC-2 (Ivabradine)") { return "#99C2A2"; }
        else if (label == "SLEEP-1 (Modafinil/Solriamfetol)") { return "#f4a261"; }
        else if (label == "SLEEP-2 (Melatonin/Light)") { return "#666B41"; }
        else if (label == "ENERGIZE-1 (Cardiopulmonary Rehab)") { return "#A26B73"; }
        else if (label == "ENERGIZE-2 (Structured Pacing)") { return "#4D6C80"; }
        else if (label == "VITAL-Unassigned") { return "#51727d"; } //blue
        else if (label == "NEURO-Unassigned") { return "#947c41"; } //yellow
        else if (label == "AUTONOMIC-Unassigned") { return "#635366"; } //pink
        else return "black";
    }

    public createChartData(participants: Participant[]): ChartDataPoint[] {

        let data: ChartDataPoint[] = [];

        if (participants.length == 0) return data;
        //console.log(participants);

        let dayMonthDictionary: Map<number, number[]> = new Map<number, number[]>(); //value: array of counts by study (to facilitate rate computations)

        participants.forEach((p: Participant) => {
            let studyCounts: number[] = [];
            let count: number = 0;
            let dateOfInterest: number = 0;

            if (this.parent.selectedPopulation == "randomized") {
                dateOfInterest = (this.parent.selectedGraphView == 'Cumulative') ? p.DateRandomized.getTime() : p.MonthRandomized.getTime();
                if (this.parent.selectedGraphView == 'ByWeek') {
                    dateOfInterest = p.WeekRandomized.getTime();
                }
            }
            else if (this.parent.selectedPopulation == "consented" || this.parent.selectedPopulation == "screen-failed") {
                dateOfInterest = (this.parent.selectedGraphView == 'Cumulative') ? p.DateConsented.getTime() : p.MonthConsented.getTime();
                if (this.parent.selectedGraphView == 'ByWeek') {
                    dateOfInterest = p.WeekConsented.getTime();
                }
            }

            if (dateOfInterest > 0) {
                if (dayMonthDictionary.has(dateOfInterest)) {
                    studyCounts = dayMonthDictionary.get(dateOfInterest);
                }
                if (studyCounts[p.StudyId] == undefined) studyCounts[p.StudyId] = 0;
                studyCounts[p.StudyId] += 1;
                dayMonthDictionary.set(dateOfInterest, studyCounts);
            }
        });

        //add up cummulative enrollment over time
        let lastDate: number = -1;
        let countToDate: number = 0;
        dayMonthDictionary.forEach((studyCounts: number[], date: number) => {
            if (this.parent.selectedGraphView == 'Cumulative') { countToDate += SumArrayElements(studyCounts); }
            else if (this.parent.selectedGraphView == 'ByMonth') { countToDate = SumArrayElements(studyCounts); }
            else if (this.parent.selectedGraphView == 'ByWeek') { countToDate = SumArrayElements(studyCounts); }
            else if (this.parent.selectedGraphView == "RatePerSiteByMonth") {
                countToDate = 0;
                [...studyCounts].forEach((count: number, index: number) => { //index is studyId
                    if (count != undefined) {
                        let sitesActivated: number = this.parent.sitesActivatedByMonthByStudy.get(index + "_" + date);
                        //countToDate += count / this.parent.siteActivationStudyTimestampMap.get(index).filter((x: number) => x <= date).length;
                        countToDate += count / sitesActivated;
                    }
                    //console.log(countToDate);
                });
            }

            if (date != lastDate) {
                //if (lastDate != -1) {
                data.push(new ChartDataPoint(date, countToDate));
                //}
                lastDate = date;
            }
        });

        //console.log(data);

        return data;
    }

    private createForecastChartSeries(): ChartSeries {
        let forecastSeries: ChartSeries = this.createChartSeries(1, 1);

        let isCumulative: boolean = (this.parent.selectedGraphView == "Cumulative");

        //console.log(this.parent.selectedForecastRandomized);

        forecastSeries.data = CreateSeries_ActualDays(this.parent.selectedForecastRandomized, isCumulative, []).map((points: any[]) => {
            if (this.parent.selectedGraphView == "Cumulative" || this.parent.selectedGraphView == "ByMonth") { return new ChartDataPoint(points[0], points[1]); }
            else if (this.parent.selectedGraphView == "RatePerSiteByMonth") { return new ChartDataPoint(points[0], points[1]); }
        });

        return forecastSeries;
    }
}

export class ChartSetup {
    constructor(public series: (ChartSeries | CategoryChartSeries)[], public showForecast: boolean, public moreThan15Points: boolean, public showLegend: boolean) { }
}

export class ChartSeries {
    data: ChartDataPoint[];
    step: string = 'left';
    //step: string = undefined;
    name: string;
    color: string;
    type: string = "line";
    marker: any;
    legendIndex: number;
    dashStyle: string = 'solid';
    connectorWidth: number = 1;

    constructor(chartView: string = 'Cumulative') {
        if (chartView == 'ByMonth' || chartView == "RatePerSiteByMonth" || chartView == "ByWeek") {
            delete this.step;
            delete this.type;
            delete this.marker;
        }
    }
}

export class ChartDataPoint {
    x: number; 
    y: number;

    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }
}

export class CategoryChartSeries {
    data: number[];
    step: string = 'left';
    name: string;
    color: string;
    type: string = "line";
    marker: any;
    legendIndex: number;
    dashStyle: string = 'solid';
    connectorWidth: number = 1;
}